import { render } from "./FluxoCadastroAbas.vue?vue&type=template&id=147434f8&scoped=true"
import script from "./FluxoCadastroAbas.vue?vue&type=script&lang=js"
export * from "./FluxoCadastroAbas.vue?vue&type=script&lang=js"

import "./FluxoCadastroAbas.vue?vue&type=style&index=0&id=147434f8&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147434f8"]])

export default __exports__